import SyncableModel from './SyncableModel';

export default class Disease extends SyncableModel {
    static name = 'Disease'

    _fillable = [
      'id',
      'full_name', 'short_name',
      'image', 'slug',
      'meta_description', 'meta_keywords',
      'status', 'indication',
      'pathogen', 'effect', 'stability_viability',
      'handling', 'regulation',
      'reference',
      'created_by', 'updated_by',
      'created_at', 'updated_at',
      'synced_at', 'deleted_at',
    ]

    static endpoint = '/diseases'

    static syncOnly = true

    static searchables = ['full_name', 'short_name']
}
